import {defineMessages} from "@project/i18n";

export const materialFieldLabelIds = {
  code: "fields.material.code",
  internalDescription: "fields.material.internalDescription",
  isPriceProtected: "fields.material.isPriceProtected",
  name: "fields.material.name",
  initialSupplierId: "fields.material.initialSupplierId",
  supplierIds: "fields.material.supplierIds",
  unitOfMeasureCode: "fields.material.unitOfMeasureCode",
} as const;

export const materialFieldMessages = defineMessages({
  code: {
    id: "fields.material.code",
    defaultMessage: "Code",
    description: "Material field label for code",
  },
  internalDescription: {
    id: "fields.material.internalDescription",
    defaultMessage: "Internal description",
    description: "Material field label for internal description",
  },
  isPriceProtected: {
    id: "fields.material.isPriceProtected",
    defaultMessage: "Price protected",
    description: "Material field label for price protection flag",
  },
  name: {
    id: "fields.material.name",
    defaultMessage: "Name",
    description: "Material field label for name",
  },
  initialSupplierId: {
    id: "fields.material.initialSupplierId",
    defaultMessage: "Initial supplier",
    description: "Material initial supplier field label",
  },
  supplierIds: {
    id: "fields.material.supplierIds",
    defaultMessage: "Suppliers",
    description: "Material field label for supplier IDs",
  },
  unitOfMeasureCode: {
    id: "fields.material.unitOfMeasureCode",
    defaultMessage: "Unit of measure",
    description: "Material field label for unit of measure code",
  },
});
